import { Extension } from '@tiptap/core';
import { Fragment } from '@tiptap/pm/model';
import { Plugin } from '@tiptap/pm/state';

export const WrapParagraphsExtension = Extension.create({
  name: 'wrapParagraphsInTableCells',

  addProseMirrorPlugins() {
    return [
      new Plugin({
        appendTransaction: (transactions, oldState, newState) => {
          if (!transactions.some((tr) => tr.docChanged)) {
            return null;
          }

          const { schema } = newState;
          const tr = newState.tr;

          if (!schema.nodes.tableHeader || !schema.nodes.tableHeaderLeafNode) {
            return null;
          }

          const replacements: { from: number; to: number; node: any }[] = [];

          // collect replacements first
          newState.doc.descendants((node, pos) => {
            if (
              node.type === schema.nodes.tableHeader &&
              node.attrs?.ghost === false
            ) {
              const firstChild = node.firstChild;
              const isFirstLeaf =
                firstChild?.type === schema.nodes.tableHeaderLeafNode;

              if (!isFirstLeaf) {
                const leafType = schema.nodes.tableHeaderLeafNode;

                if (!leafType) {
                  return;
                }

                // If empty, create a valid paragraph
                let content = node.content;

                if (node.content.size === 0) {
                  // createAndFill ensures a valid node (fallback to empty text if needed)
                  const paragraph =
                    schema.nodes.paragraph.createAndFill() ||
                    schema.nodes.paragraph.create({}, schema.text(''));

                  content = Fragment.from(paragraph);
                }

                const wrapped = leafType.create({}, content);
                const newTableHeader = schema.nodes.tableHeader.create(
                  node.attrs,
                  Fragment.from(wrapped),
                );

                // replace the entire node (use pos .. pos + node.nodeSize)
                replacements.push({
                  from: pos,
                  to: pos + node.nodeSize,
                  node: newTableHeader,
                });
              }
            }
          });

          if (replacements.length === 0) {
            return null;
          }

          // apply replacements in reverse order to avoid shifting positions
          replacements
            .sort((a, b) => b.from - a.from)
            .forEach(({ from, to, node }) => {
              tr.replaceWith(from, to, node);
            });

          return tr;
        },
      }),
    ];
  },
});
